export default __webpack_public_path__ + "static/media/popularna.29c5cede.png";